<div *ngIf="!data.contactDisplay">
<div class="modal-header modalHeaderBlack">
  <h6 class="modal-title">
    {{ "AppointmentListPage.reasonforReschedule" | translate }}
  </h6>
  <span
    aria-label="Close"
    class="close"
    (click)="onNoClick()"
    data-automation-attribute="span-close-dialog"
  >
    <mat-icon matTooltip="Close">clear</mat-icon>
  </span>
</div>
<div style="margin-left: 10px">
  <div style="margin-top: 10px">
    <h6>{{ "billing.reason" | translate }} : {{ reasonValue }}</h6>
  </div>
  <div style="margin-top: 10px">
    <h6>
      {{ "AppointmentListPage.remarks" | translate }} : {{ remarksValue }}
    </h6>
  </div>
</div>
</div>
<div *ngIf="data.contactDisplay">
<div class="modal-header modalHeaderBlack" >
  <h6 class="modal-title">
    {{'AppointmentListPage.contactDetails' | translate}}
  </h6>
  <span
    aria-label="Close"
    class="close"
    (click)="onNoClick()"
    data-automation-attribute="span-close-dialog"
  >
    <mat-icon matTooltip="Close">clear</mat-icon>
  </span>
</div>
<div style="margin-left: 10px" >
  <div style="margin-top: 10px">
    <h6>{{'AppointmentListPage.contactNo' | translate}} : {{data.mobileNumber}}</h6>
  </div>
  <div style="margin-top: 10px">
    <h6>
      {{'AppointmentListPage.emailId' | translate}} : {{data.emailId}}
    </h6>
  </div>
</div>
</div>